import type { GetCurrentSponsorPlaceholdersResponse } from '@/services/api/api.types'

export interface TerminologyItem {
  id: keyof GetCurrentSponsorPlaceholdersResponse
  label: string
  tooltip?: string
}

export const DisabledTerminology: string[] = []

export const RequiredTerminology: TerminologyItem[] = [
  {
    id: 'sponsorName',
    label: 'Customer Name',
    tooltip: 'How should the Sidekicks to refer to your organization?',
  },
  {
    id: 'sponsorNameShort',
    label: 'Customer Short Name',
    tooltip: 'If you have a short name or nickname for your organization, what is it?​',
  },
  {
    id: 'userTypeName',
    label: 'End User Role',
    tooltip: 'How should the Sidekicks to refer to your End Users?',
  },
  // {
  //   id: 'sponsorCrisisInstruction',
  //   label: 'Emergency Contact',
  //   tooltip: 'Where should Sidekicks direct App Users if they say that they are in an emergency?',
  // },
]

// export const OptionalTerminology: TerminologyItem[] = [
//   {
//     id: 'expertSidekick',
//     label: 'Expert Sidekick',
//     tooltip: 'The expert sidekick that will be used in the application.',
//   },
//   {
//     id: 'roadToSuccess',
//     label: 'Road to Success',
//     tooltip: 'The road to success that will be used in the application.',
//   },
//   {
//     id: 'roadToSuccessShort',
//     label: 'Road to Success Nickname',
//     tooltip: 'The nickname of the road to success that will be used in the application.',
//   },
//   {
//     id: 'roadToSuccessItem',
//     label: 'Road to Success Item',
//     tooltip: 'The item of the road to success that will be used in the application.',
//   },
//   {
//     id: 'memberSidekickType',
//     label: 'Member Sidekick',
//     tooltip: 'The member sidekick that will be used in the application.',
//   },
//   { id: 'step', label: 'Step', tooltip: 'The step that will be used in the application.' },
//   {
//     id: 'frequentlyAskedQuestion',
//     label: 'FAQ',
//     tooltip: 'The frequently asked question that will be used in the application.',
//   },
//   {
//     id: 'smeTerm',
//     label: 'SME Term',
//     tooltip: 'The SME term that will be used in the application.',
//   },
//   {
//     id: 'subjectMatterExpert',
//     label: 'Subject Matter Expert',
//     tooltip: 'The subject matter expert that will be used in the application.',
//   },
// ]
